export const capitalizeString = (stringToTransform: string) => {
  if (stringToTransform === '') return stringToTransform;

  return `${stringToTransform.charAt(0).toUpperCase()}${stringToTransform.slice(1)}`;
};
